import Vue from 'vue';
import App from './App.vue';
import Vuei18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
import './registerServiceWorker';
import router from '@/router';
import VueGtag from 'vue-gtag';
import 'owl.carousel';
import 'slicknav/dist/jquery.slicknav';
window.$ = window.jQuery = require('jquery');

Vue.use(VueGtag, {
  config: { id: '216605689' },
  params: {
    send_page_view: true,
  },
});

// import "jquery/dist/jquery.min.js"
import '@/assets/css/vendor.min.css';
import '@/assets/css/plugins.min.css';
import '@/assets/css/tailwind.css';
import '@/assets/css/slick.css';
import 'vue-select/dist/vue-select.css';
import '@/assets/css/style.css';
import i18n from '@/plugins/i18n';
import 'popper.js/dist/popper.min.js';
import FlagIcon from 'vue-flag-icon';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(FlagIcon);
Vue.config.productionTip = false;
Vue.use(Vuei18n);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(BootstrapVueIcons);

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app');
